import React, { Component } from "react";
import {
    Page,
    Text,
    View,
    Document,
    StyleSheet
} from "@react-pdf/renderer";
import PropTypes from "prop-types";
import moment from 'moment'

const styles = StyleSheet.create({
    page: {
        backgroundColor: "#ffffff",
        margin: 20
    },
    section: {
        margin: 10,
        padding: 10,
        flexGrow: 1
    },
    headline: {
        textAlign: 'center', // <-- the magic
        fontWeight: 'bold',
        fontSize: 12,
        marginTop: 50,
        textDecorationLine: 'underline'
    },
    textheaderline: {
        fontWeight: 'bold',
        fontSize: 12,
        textDecorationLine: 'underline'
    },
    subheadline: {
        textAlign: 'center', // <-- the magic
        fontSize: 10
    },
    table: {
        display: "table",
        width: "auto"
    },
    tableRow: {
        margin: "auto",
        flexDirection: "row"
    },
    tableColHeaderFirst: {
        width: "30",
        borderStyle: "solid",
        borderColor: '#000000',
        borderWidth: 1,
        backgroundColor: '#DDDDDD'
    },
    tableColHeader: {
        width: "15%",
        borderStyle: "solid",
        borderColor: '#000000',
        borderWidth: 1,
        borderLeftWidth: 0,
        backgroundColor: '#DDDDDD'
    },
    tableColFirst: {
        width: "30",
        borderStyle: "solid",
        borderColor: '#000000',
        borderWidth: 1,
        borderTopWidth: 0
    },
    tableCol: {
        width: "15%",
        borderStyle: "solid",
        borderColor: '#000000',
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0
    },
    tableCellHeader: {
        margin: 5,
        fontSize: 10,
        fontWeight: 500
    },
    tableCell: {
        margin: 5,
        fontSize: 10
    }
});

class PdfDocument extends Component {
    static propTypes = {
        data: PropTypes.instanceOf(Array)
    };

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <Document>
                <Page style={styles.page}>
                    <View style={styles.headline}><Text style={styles.textheaderline}>SURAT PENGANTAR DOKUMEN CLAIM</Text></View>
                    <View style={styles.subheadline}><Text style={styles.textheaderline}>AWB No: {this.props.awb_no}</Text></View>
                    <View style={styles.table}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColHeaderFirst}>
                                <Text style={styles.tableCellHeader}>No</Text>
                            </View>
                            <View style={styles.tableColHeader}>
                                <Text style={styles.tableCellHeader}>Claim No</Text>
                            </View>
                            <View style={styles.tableColHeader}>
                                <Text style={styles.tableCellHeader}>Customer Name</Text>
                            </View>
                            <View style={styles.tableColHeader}>
                                <Text style={styles.tableCellHeader}>Principal</Text>
                            </View>
                            <View style={styles.tableColHeader}>
                                <Text style={styles.tableCellHeader}>Amount</Text>
                            </View>
                            <View style={styles.tableColHeader}>
                                <Text style={styles.tableCellHeader}>Submitted Date</Text>
                            </View>
                        </View>
                        {this.props.data.map((item, index) => {
                            return (
                                <View style={styles.tableRow}>
                                    <View style={styles.tableColFirst}><Text style={styles.tableCell}>{index + 1}</Text></View>
                                    <View style={styles.tableCol}><Text style={styles.tableCell}>{item.claim_number}</Text></View>
                                    <View style={styles.tableCol}><Text style={styles.tableCell}>{item.customer_name}</Text></View>
                                    <View style={styles.tableCol}><Text style={styles.tableCell}>{item.org_initial}</Text></View>
                                    <View style={styles.tableCol}><Text style={styles.tableCell}>{item.total}</Text></View>
                                    <View style={styles.tableCol}><Text style={styles.tableCell}>{moment(item.creation_date).format('DD-MMM-YYYY HH:mm:ss')}</Text></View>
                                </View>
                            )
                        })}
                    </View>
                </Page>
            </Document >
        );
    }
}

export default PdfDocument